import { render, staticRenderFns } from "./TransparencySubTypesHeader.vue?vue&type=template&id=6ae59756&scoped=true&"
import script from "./TransparencySubTypesHeader.vue?vue&type=script&lang=js&"
export * from "./TransparencySubTypesHeader.vue?vue&type=script&lang=js&"
import style0 from "./TransparencySubTypesHeader.vue?vue&type=style&index=0&id=6ae59756&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae59756",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCardTitle,VIcon,VTextField})
